import { CommonModule } from '@angular/common';
import { Component, NgModule, Output, Input, EventEmitter, ElementRef, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';

import * as events from 'devextreme/events';
import { CommonService } from '../../services/common.service';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { DxButtonModule } from 'devextreme-angular';
import { IntroTourService } from '../../services/intro-tour.service';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss'],
  standalone: false
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  // @ViewChild('menu', null) menu: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  @Input()
  items: any[];

  @Input()
  // set 
  selectedItem;
  // (value: string) {
  //   if (this.menu.instance) {
  //     this.menu.instance.selectItem(value);
  //   }
  // }

  private _compactMode = false;
  @Input()
  // get 
  compactMode;
  // () {
  //   return this._compactMode;
  // }
  // set compactMode(val) {
  //   this._compactMode = val;
  //   if (val && this.menu.instance) {
  //     this.menu.instance.collapseAll();
  //   }
  // }

  selectedRoute = '/home';
  getAuthInfo: any;
  isESS = false;
  isShaktigarh = false;
  constructor(private elementRef: ElementRef, public common: CommonService, private enc: EncryptDecryptService,
    public introTourService: IntroTourService) {
    this.getAuthInfo = this.common.fnGetAuthInfo();
    if (this.getAuthInfo[0].isESS === 'ESS') {
      this.isESS = true;
    }
    if (this.getAuthInfo[0].isESS === 'WP') {
      this.isESS = false;
    }
    this.isShaktigarh = this.getAuthInfo[0].cid === 2026;
  }

  updateSelection(event, isActive) {
    const nodeClass = 'dx-treeview-node';
    const selectedClass = 'dx-state-selected';
    const leafNodeClass = 'dx-treeview-node-is-leaf';
    const element: HTMLElement = event.element;
    const rootNodes = element.querySelectorAll(`.${nodeClass}.${leafNodeClass}`);
    // Array.from(rootNodes).forEach(node => {
    //   node.classList.remove(selectedClass);
    // });
    // tslint:disable-next-line: prefer-for-of

    if (sessionStorage.getItem(this.enc.encryptUsingAES256('isActive')) === 'true') {
      sessionStorage.setItem(this.enc.encryptUsingAES256('isActive'), 'false');
      for (let index = 0; index < rootNodes.length; index++) {
        rootNodes[index].classList.remove(selectedClass);
        if (rootNodes.length === index + 1) {
          rootNodes[0].classList.add(selectedClass);
        }
      }
    }


    // let selectedNode = element.querySelector(`.${nodeClass}.${selectedClass}`);
    // while (selectedNode && selectedNode.parentElement) {
    //   if (selectedNode.classList.contains(nodeClass)) {
    //     selectedNode.classList.add(selectedClass);
    //   }

    //   selectedNode = selectedNode.parentElement;
    // }
  }

  onItemClick(event) {
    // this.selectedRoute = event.itemData.path;
    // this.selectedItemChanged.emit(event);
    this.selectedItemChanged.emit(event);
  }

  onMenuInitialized(event) {
    event.component.option('deferRendering', false);
  }

  ngAfterViewInit() {
    // events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
    //   this.openMenu.next(e);
    // });
    // this.isShowTourBtn = this.introTourService.fnTourStatusCheck('Side_Navigation_MenuTour');
    // if (this.introTourService.fnTourStatusCheck('Side_Navigation_MenuTour') && this.isESS) {
    //   setTimeout(() => {
    //     this.fnNavigationMenuTour();
    //   }, 200);
    // }
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }

  isShowTourBtn: boolean = false;
  homeTourArr: any[];

  addTourElement(elementId, title, intro) {
    const element = document.getElementById(elementId);
    if (element) {
      this.homeTourArr.splice(this.homeTourArr.length - 1, 0, { title, element, intro, });
    }
  }

  fnNavigationMenuTour() {
    this.homeTourArr = [
      {
        title: 'Navigation Help Tour',
        element: document.getElementById('NavMenu'),
        intro: `It's a quick overview of the navigation menu features.`,
      },
      {
        title: 'Thank You',
        intro: 'The ESS Navigation Menu Tour has been successfully completed.',
      },
    ];

    this.addTourElement('/ESS-Home', 'Home', `<b>Quick access to</b><br>Mark Attendance<br>Action Pending <br>Your Request etc.. `);
    this.addTourElement('/My-Details', `Me`, `Quick access to <br>Attendance Details <br>Leave Info. <br>My Documents <br>Team Members.`);
    this.addTourElement('/Financials', 'Financials', `Access to financial records, <br>Download Payslip <br>Reimbursement<br>Invesment Declarations`);
    this.addTourElement('/HR-Activities', 'HR Activities', `Interaction with HR-related tasks, like <br>Help Desk Requests and Other Request`);
    this.addTourElement('/Assets', 'Assets', `Assets Assigned to you`);
    this.addTourElement('/Employee-Directory', 'Employee Directory', `A searchable directory of employees`);
    this.addTourElement('/Social', 'Social', `Birthdays, and Work Anniversaries etc..`);

    this.introTourService.fnStartTour('Side_Navigation_MenuTour', this.homeTourArr, () => {
      this.isShowTourBtn = this.introTourService.fnTourStatusCheck('Side_Navigation_MenuTour');
    });
  }


}


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule
  ],
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent]
})
export class SideNavigationMenuModule { }
